class Callbacks {
  static filterToFormHandler() {
    return function filterToForm(filter) {
      return {
        ...filter
      }
    }
  }
  static filterToStateHandler() {
    return function filterToState(state) {
      return {
      }
    }
  }
  static formToFilterHandler(company) {
    return function formToFilter(values, extra, meta, state) {
      return {
        company
      }
    }
  }
  static recordToFormHandler() {
    return function recordToForm(record) {
      return {
        ...record,
      }
    }
  }

  static formToRecordHandler(company) {
    return function formToRecord(values, extra, meta) {
      return {
        company,
        ...values
      }
    }
  }
}

export default Callbacks
